import React, { useState, useEffect } from 'react';

import copyLinkToClipboard from '../../helpers/copyLinkToClipboard';

import linkIcon from '../../../../../../assets/img/link.svg';
import arrowDownPurple from '../../../../../../assets/img/arrow-down-purple.svg';
import styles from './WebSurveyRedirections.module.css';
import Dropdown from '../Conversion/components/Dropdown/Dropdown';
import {
  SURVEY_REDIRECTION_INPUT_USER_PROPERTIES,
  SURVEY_REDIRECTION_URL_PROPERTY_TYPES,
  surveyRedirectionLinkTypes,
  TRANSFER_INPUT_PATH_URL_PARAM_TYPES
} from '../../../../../helpers/constants';
import deleteIcon from '../../../../../assets/x.svg';
import CustomCopyField from '../WebSurveyCustomCopy/components/CustomCopyField';
import DutchStrings from '../../../../../../../users/strings/nl';
import FrenchStrings from '../../../../../../../users/strings/fr';
import EnglishStrings from '../../../../../../../users/strings/en';
import GermanStrings from '../../../../../../../users/strings/de';
import { getCustomCopyFieldValue } from '../WebSurveyCustomCopy/WebSurveyCustomCopy';

const urlPropertyTransferTypeLabels = {
  [SURVEY_REDIRECTION_URL_PROPERTY_TYPES.TRANSFER_INPUT_PATH_URL_PARAM]:
    'Path parameter',
  [SURVEY_REDIRECTION_URL_PROPERTY_TYPES.TRANSFER_INPUT_QUERY_URL_PARAM]:
    'Query parameter',
  [SURVEY_REDIRECTION_URL_PROPERTY_TYPES.USER_PROPERTY_OUTPUT]: 'User parameter'
};

const transferInputPathUrlParamTypes = {
  [TRANSFER_INPUT_PATH_URL_PARAM_TYPES.CUSTOM_CLIENT_IDENTIFIER]:
    'Custom client identifier',
  [TRANSFER_INPUT_PATH_URL_PARAM_TYPES.CUSTOM_CLIENT_NAME]: 'Custom client name'
};

const userPropertyOutputTypes = {
  [SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.USER_ID]: 'User ID',
  [SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.ENCRYPTED_USER_ID]:
    'Encrypted User ID',
  [SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.RESULT_ID]: 'Result ID',
  [SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.EMAIL]: 'Email',
  [SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.AGE]: 'Age',
  [SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.GENDER]: 'Gender'
};

const redirectionTypes = [
  {
    label: 'Survey end successfully',
    name: surveyRedirectionLinkTypes.SUCCESS,
    placeholder: 'URL in case survey end successfully'
  },
  {
    label: 'Survey failed',
    name: surveyRedirectionLinkTypes.FAILED,
    placeholder:
      'URL in case respondents are filtered out during survey (not eligible, answer option quota, not accepting privacy policy)'
  },
  {
    label: 'Quota full',
    name: surveyRedirectionLinkTypes.QUOTA_FULL,
    placeholder:
      'URL in case respondents are filtered out due to socio demographics'
  }
];

const customCopyTranslationKeys = {
  SURVEY_REDIRECTION_PAGE_TITLE: 'SURVEY_REDIRECTION_PAGE_TITLE',
  SURVEY_REDIRECTION_PAGE_DESCRIPTION: 'SURVEY_REDIRECTION_PAGE_DESCRIPTION',
  SURVEY_REDIRECTION_PAGE_BUTTON: 'SURVEY_REDIRECTION_PAGE_BUTTON'
};

function URLProperties({
  transferType,
  inputPathProperty,
  outputPropertyName,
  inputUserProperty,
  inputPropertyName,
  urlPropertyIndex,
  onDeleteURLProperty,
  updateURLPropertyItem,
  onInputBlur
}) {
  return (
    <div
      key={`url-properties-container-${urlPropertyIndex.toString()}`}
      className={styles.urlProperty}
    >
      <div className={styles.urlPropertyColumn}>
        <Dropdown
          customPlaceholder="Select type"
          onSelectCompleted={(label, value) => {
            updateURLPropertyItem(
              urlPropertyIndex,
              'transferType',
              value,
              true,
              true
            );
          }}
          options={[
            { value: null, label: '-' },
            {
              value:
                SURVEY_REDIRECTION_URL_PROPERTY_TYPES.TRANSFER_INPUT_PATH_URL_PARAM,
              label:
                urlPropertyTransferTypeLabels[
                  SURVEY_REDIRECTION_URL_PROPERTY_TYPES
                    .TRANSFER_INPUT_PATH_URL_PARAM
                ]
            },
            {
              value:
                SURVEY_REDIRECTION_URL_PROPERTY_TYPES.TRANSFER_INPUT_QUERY_URL_PARAM,
              label:
                urlPropertyTransferTypeLabels[
                  SURVEY_REDIRECTION_URL_PROPERTY_TYPES
                    .TRANSFER_INPUT_QUERY_URL_PARAM
                ]
            },
            {
              value: SURVEY_REDIRECTION_URL_PROPERTY_TYPES.USER_PROPERTY_OUTPUT,
              label:
                urlPropertyTransferTypeLabels[
                  SURVEY_REDIRECTION_URL_PROPERTY_TYPES.USER_PROPERTY_OUTPUT
                ]
            }
          ]}
          loading={false}
          selectedValue={
            transferType ? urlPropertyTransferTypeLabels[transferType] : null
          }
          fixedPosition
        />
      </div>
      {transferType ===
      SURVEY_REDIRECTION_URL_PROPERTY_TYPES.TRANSFER_INPUT_PATH_URL_PARAM ? (
        <>
          <div className={styles.urlPropertyColumn}>
            <Dropdown
              customPlaceholder="Select type"
              onSelectCompleted={(label, value) => {
                updateURLPropertyItem(
                  urlPropertyIndex,
                  'inputPathProperty',
                  value,
                  false,
                  true
                );
              }}
              options={[
                { value: null, label: '-' },
                {
                  value:
                    TRANSFER_INPUT_PATH_URL_PARAM_TYPES.CUSTOM_CLIENT_IDENTIFIER,
                  label:
                    transferInputPathUrlParamTypes[
                      TRANSFER_INPUT_PATH_URL_PARAM_TYPES
                        .CUSTOM_CLIENT_IDENTIFIER
                    ]
                },
                {
                  value: TRANSFER_INPUT_PATH_URL_PARAM_TYPES.CUSTOM_CLIENT_NAME,
                  label:
                    transferInputPathUrlParamTypes[
                      TRANSFER_INPUT_PATH_URL_PARAM_TYPES.CUSTOM_CLIENT_NAME
                    ]
                }
              ]}
              loading={false}
              selectedValue={
                inputPathProperty
                  ? transferInputPathUrlParamTypes[inputPathProperty]
                  : null
              }
              fixedPosition
            />
          </div>
          <div className={styles.urlPropertyColumn}>
            <input
              value={outputPropertyName || ''}
              onChange={e =>
                updateURLPropertyItem(
                  urlPropertyIndex,
                  'outputPropertyName',
                  e.target.value
                )
              }
              onBlur={onInputBlur}
              placeholder="Output variable name"
              className={styles.inputField}
            />
          </div>
        </>
      ) : null}
      {transferType ===
      SURVEY_REDIRECTION_URL_PROPERTY_TYPES.TRANSFER_INPUT_QUERY_URL_PARAM ? (
        <>
          <div className={styles.urlPropertyColumn}>
            <input
              value={inputPropertyName || ''}
              onChange={e =>
                updateURLPropertyItem(
                  urlPropertyIndex,
                  'inputPropertyName',
                  e.target.value
                )
              }
              onBlur={onInputBlur}
              placeholder="Input variable name"
              className={styles.inputField}
            />
          </div>
          <div className={styles.urlPropertyColumn}>
            <input
              value={outputPropertyName || ''}
              onChange={e =>
                updateURLPropertyItem(
                  urlPropertyIndex,
                  'outputPropertyName',
                  e.target.value
                )
              }
              onBlur={onInputBlur}
              placeholder="Output variable name"
              className={styles.inputField}
            />
          </div>
        </>
      ) : null}
      {transferType ===
      SURVEY_REDIRECTION_URL_PROPERTY_TYPES.USER_PROPERTY_OUTPUT ? (
        <>
          <div className={styles.urlPropertyColumn}>
            <Dropdown
              customPlaceholder="Select type"
              onSelectCompleted={(label, value) => {
                updateURLPropertyItem(
                  urlPropertyIndex,
                  'inputUserProperty',
                  value,
                  false,
                  true
                );
              }}
              options={[
                { value: null, label: '-' },
                {
                  value: SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.USER_ID,
                  label:
                    userPropertyOutputTypes[
                      SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.USER_ID
                    ]
                },
                {
                  value:
                    SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.ENCRYPTED_USER_ID,
                  label:
                    userPropertyOutputTypes[
                      SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.ENCRYPTED_USER_ID
                    ]
                },
                {
                  value: SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.RESULT_ID,
                  label:
                    userPropertyOutputTypes[
                      SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.RESULT_ID
                    ]
                },
                {
                  value: SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.EMAIL,
                  label:
                    userPropertyOutputTypes[
                      SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.EMAIL
                    ]
                },
                {
                  value: SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.AGE,
                  label:
                    userPropertyOutputTypes[
                      SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.AGE
                    ]
                },
                {
                  value: SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.GENDER,
                  label:
                    userPropertyOutputTypes[
                      SURVEY_REDIRECTION_INPUT_USER_PROPERTIES.GENDER
                    ]
                }
              ]}
              loading={false}
              selectedValue={
                inputUserProperty
                  ? userPropertyOutputTypes[inputUserProperty]
                  : null
              }
              fixedPosition
            />
          </div>
          <div className={styles.urlPropertyColumn}>
            <input
              value={outputPropertyName || ''}
              onChange={e =>
                updateURLPropertyItem(
                  urlPropertyIndex,
                  'outputPropertyName',
                  e.target.value
                )
              }
              onBlur={onInputBlur}
              placeholder="Output variable name"
              className={styles.inputField}
            />
          </div>
        </>
      ) : null}

      <img
        className={styles.deleteUrlPropertyIcon}
        alt="Delete filer"
        role="presentation"
        src={deleteIcon}
        onClick={() => onDeleteURLProperty(urlPropertyIndex)}
      />
    </div>
  );
}

function WebSurveyRedirections(props) {
  const {
    survey,
    updateSurveySettings,
    updateSurveyProperties,
    isAdmin,
    updateCustomCopies
  } = props;
  const [surveyRedirections, setSurveyRedirections] = useState([]);
  const [activeSurveyRedirectionIndex] = useState(0);

  const [expanded, setExpanded] = useState(false);
  const [linkCopied, setLinkCopied] = useState({});
  const [customCopyFields, setCustomCopyFields] = useState({});
  const [showAdvancedConfiguration, setShowAdvancedConfiguration] = useState(
    false
  );

  useEffect(
    () => {
      if (!survey) return;

      // New system
      const processedSurveyRedirections = survey.surveyRedirections.map(sR => {
        const newSR = { ...sR };

        newSR.urlPropertiesTransfer = newSR.urlPropertiesTransfer.map(uPT => {
          const newUPT = { ...uPT };

          delete newUPT.__typename;
          return newUPT;
        });

        newSR.redirections = newSR.redirections.map(r => {
          const newR = { ...r };

          delete newR.__typename;
          return newR;
        });

        delete newSR.__typename;

        return newSR;
      });
      setSurveyRedirections(processedSurveyRedirections);

      // Custom translations
      if (survey) {
        setCustomCopyFields(translationFields);
      }
    },
    [survey]
  );

  const strings = {
    Dutch: DutchStrings,
    French: FrenchStrings,
    English: EnglishStrings,
    German: GermanStrings
  };

  const surveyLanguage = (survey && survey.language) || 'English';

  const customCopies =
    survey && survey.customCopies && survey.customCopies.length
      ? survey.customCopies
      : [];

  const translations = strings[surveyLanguage];

  const translationFields = [
    customCopyTranslationKeys.SURVEY_REDIRECTION_PAGE_TITLE,
    customCopyTranslationKeys.SURVEY_REDIRECTION_PAGE_DESCRIPTION,
    customCopyTranslationKeys.SURVEY_REDIRECTION_PAGE_BUTTON
  ].reduce(
    (acc, t) => ({
      ...acc,
      [t]: getCustomCopyFieldValue(
        t,
        surveyLanguage,
        customCopies,
        translations
      )
    }),
    {}
  );

  const onDeleteURLPropertyClick = index => {
    const newSurveyRedirections = [...surveyRedirections];

    const newSurveyRedirectionTab = {
      ...newSurveyRedirections[activeSurveyRedirectionIndex]
    };

    newSurveyRedirectionTab.urlPropertiesTransfer.splice(index, 1);

    setSurveyRedirections(newSurveyRedirections);

    updateSurveyProperties(
      {
        surveyRedirections: newSurveyRedirections
      },
      false
    );
  };

  const onAddURLPropertyClick = () => {
    const newSurveyRedirections = [...surveyRedirections];

    newSurveyRedirections[activeSurveyRedirectionIndex] = {
      ...newSurveyRedirections[activeSurveyRedirectionIndex],
      urlPropertiesTransfer: [
        ...(newSurveyRedirections[activeSurveyRedirectionIndex]
          ? newSurveyRedirections[activeSurveyRedirectionIndex]
              .urlPropertiesTransfer
          : []),
        {
          transferType: null
        }
      ]
    };

    setSurveyRedirections(newSurveyRedirections);

    updateSurveyProperties(
      {
        surveyRedirections: newSurveyRedirections
      },
      false
    );
  };

  const updateURLPropertyItem = (
    index,
    property,
    value,
    newObject,
    updateSurvey
  ) => {
    const newSurveyRedirections = [...surveyRedirections];

    const newSurveyRedirectionTab = {
      ...newSurveyRedirections[activeSurveyRedirectionIndex]
    };

    newSurveyRedirectionTab.urlPropertiesTransfer[index] = {
      ...(newObject
        ? {}
        : newSurveyRedirectionTab.urlPropertiesTransfer[index]),
      [property]: value
    };

    setSurveyRedirections(newSurveyRedirections);

    if (updateSurvey) {
      updateSurveyProperties(
        {
          surveyRedirections: newSurveyRedirections
        },
        false
      );
    }
  };

  const onRedirectionUpdate = (type, value) => {
    const newSurveyRedirections = [...surveyRedirections];

    const newSurveyRedirectionTab = {
      ...newSurveyRedirections[activeSurveyRedirectionIndex]
    };

    const index = newSurveyRedirectionTab.redirections.findIndex(
      r => r.redirectionType === type
    );

    if (index === -1) {
      newSurveyRedirectionTab.redirections.push({
        redirectionType: type,
        url: value
      });
    }
    if (index > -1) {
      newSurveyRedirectionTab.redirections[index] = {
        ...(newSurveyRedirectionTab.redirections[index] || {}),
        url: value
      };
    }

    setSurveyRedirections(newSurveyRedirections);
  };

  const updateRedirectionFormat = e => {
    const newSurveyRedirections = [...surveyRedirections];

    newSurveyRedirections[activeSurveyRedirectionIndex] = {
      ...newSurveyRedirections[activeSurveyRedirectionIndex],
      redirectionFormat: e.currentTarget.value
    };

    setSurveyRedirections(newSurveyRedirections);
  };

  const onInputBlur = () => {
    updateSurveyProperties(
      {
        surveyRedirections
      },
      false
    );
  };

  const surveyRedirectionsToEdit =
    surveyRedirections && surveyRedirections.length
      ? surveyRedirections[activeSurveyRedirectionIndex]
      : null;

  const getRedirectionUrl = redirectionType => {
    const redirection =
      surveyRedirectionsToEdit &&
      surveyRedirectionsToEdit.redirections &&
      surveyRedirectionsToEdit.redirections.length
        ? surveyRedirectionsToEdit.redirections.find(
            r => r.redirectionType === redirectionType
          )
        : null;

    return (redirection && redirection.url) || '';
  };

  const firstRedirectionUrl = getRedirectionUrl(redirectionTypes[0].name);
  const redirectionFormatValue =
    (surveyRedirectionsToEdit && surveyRedirectionsToEdit.redirectionFormat) ||
    '';

  let redirectionFormatError = null;
  if (
    firstRedirectionUrl.indexOf('?') > -1 &&
    redirectionFormatValue.indexOf('?') > -1
  ) {
    // Both parts open a query string, the built URL would contain two of them
    redirectionFormatError =
      "Redirection format error. Double use of symbol '?'. Check Parameters Redirection Format, it must not contain '?'";
  } else if (
    firstRedirectionUrl.indexOf('?') === -1 &&
    redirectionFormatValue.indexOf('?') === -1 &&
    redirectionFormatValue.indexOf('&') > -1
  ) {
    // Parameters are chained with '&' while no query string was opened yet
    redirectionFormatError =
      "Redirection format error. Invalid 'Parameters Redirection Format' input. For this redirection link, 'Parameters Redirection Format' should start with '?'";
  }

  return (
    <div className={styles.targetAudienceTabContainer}>
      <div className={styles.container}>
        <div
          className={styles.containerTitle}
          role="presentation"
          onClick={() => setExpanded(() => setExpanded(!expanded))}
        >
          Survey Redirections
          <img
            src={arrowDownPurple}
            alt="ExpandColapse"
            className={expanded ? styles.arrowExpanded : styles.arrowCollapsed}
          />
        </div>
        {expanded ? (
          <div className={styles.blockContainer}>
            <div>
              {redirectionFormatError ? (
                <div className={styles.redirectionFormatError}>
                  {redirectionFormatError}
                </div>
              ) : null}
              {redirectionTypes.map((type, index) => (
                <div
                  className={styles.inputContainer}
                  key={`web-survey-redirection-${index.toString()}`}
                >
                  <div className={styles.link}>
                    <img
                      className={styles.websiteIcon}
                      src={linkIcon}
                      alt="Website icon"
                    />
                    <input
                      value={
                        (surveyRedirectionsToEdit &&
                          surveyRedirectionsToEdit.redirections &&
                          surveyRedirectionsToEdit.redirections.length &&
                          surveyRedirectionsToEdit.redirections.find(
                            r => r.redirectionType === type.name
                          ) &&
                          surveyRedirectionsToEdit.redirections.find(
                            r => r.redirectionType === type.name
                          ).url) ||
                        ''
                      }
                      onChange={e =>
                        onRedirectionUpdate(type.name, e.target.value)
                      }
                      onBlur={onInputBlur}
                      placeholder={type.placeholder}
                      className={`${
                        styles.urlInput
                      } web-survey-redirections-input-${type.name}`}
                    />
                  </div>
                  <div
                    className={
                      linkCopied[type.name] === true
                        ? `${styles.copyLinkButton} ${styles.copied}`
                        : styles.copyLinkButton
                    }
                    onClick={() =>
                      copyLinkToClipboard(
                        (surveyRedirectionsToEdit &&
                          surveyRedirectionsToEdit.redirections &&
                          surveyRedirectionsToEdit.redirections.length &&
                          surveyRedirectionsToEdit.redirections.find(
                            r => r.redirectionType === type.name
                          ) &&
                          surveyRedirectionsToEdit.redirections.find(
                            r => r.redirectionType === type.name
                          ).url) ||
                          '',
                        type.name,
                        linkCopied,
                        setLinkCopied
                      )
                    }
                    role="presentation"
                  >
                    {linkCopied[type.name] === true ? 'Copied' : 'Copy link'}
                  </div>
                </div>
              ))}
              {isAdmin ? (
                <div
                  className={`${styles.webSurveyRedirectionsTitle} ${
                    styles.toggleContainer
                  }`}
                >
                  <span>Advanced configuration</span>
                  <span role="presentation" className={styles.switchContainer}>
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label className={styles.switch} htmlFor="checkbox">
                      <input
                        type="checkbox"
                        checked={showAdvancedConfiguration}
                        readOnly
                      />
                      <span
                        className="slider round survey-property-show-redirection-mobile"
                        role="presentation"
                        onClick={() =>
                          setShowAdvancedConfiguration(
                            !showAdvancedConfiguration
                          )
                        }
                      />
                    </label>
                  </span>
                </div>
              ) : null}
              {isAdmin && showAdvancedConfiguration ? (
                <>
                  <div className={styles.webSurveyRedirectionsTitle}>
                    URL Properties
                  </div>
                  <div className={styles.urlPropertiesContainer}>
                    {surveyRedirectionsToEdit &&
                    surveyRedirectionsToEdit.urlPropertiesTransfer &&
                    surveyRedirectionsToEdit.urlPropertiesTransfer.length
                      ? surveyRedirectionsToEdit.urlPropertiesTransfer.map(
                          (sR, sRI) => (
                            <URLProperties
                              transferType={sR && sR.transferType}
                              inputPathProperty={sR && sR.inputPathProperty}
                              outputPropertyName={sR && sR.outputPropertyName}
                              inputUserProperty={sR && sR.inputUserProperty}
                              inputPropertyName={sR && sR.inputPropertyName}
                              urlPropertyIndex={sRI}
                              onDeleteURLProperty={onDeleteURLPropertyClick}
                              updateURLPropertyItem={updateURLPropertyItem}
                              updateSurveyProperties={updateSurveyProperties}
                              onInputBlur={onInputBlur}
                              key={`url-properties-${sRI.toString()}`}
                            />
                          )
                        )
                      : null}
                  </div>
                  <div className={styles.webSurveyRedirectionAddButton}>
                    <span onClick={onAddURLPropertyClick} role="presentation">
                      Add URL Property
                    </span>
                  </div>
                  <div
                    className={`${styles.urlPropertyColumn} ${
                      styles.urlPropertyColumnInputContainer
                    }`}
                  >
                    <div className={styles.rowText}>
                      Parameters Redirection Format
                    </div>
                    <input
                      value={
                        (surveyRedirectionsToEdit &&
                          surveyRedirectionsToEdit.redirectionFormat) ||
                        ''
                      }
                      onChange={e => updateRedirectionFormat(e)}
                      onBlur={onInputBlur}
                      placeholder="For example: /{output_variable_name (1)}?m={output_variable_name (2)}"
                      className={`${styles.inputField} ${
                        styles.inputFieldFullWidth
                      }`}
                    />
                  </div>
                  <div>
                    <div
                      className={`${styles.webSurveyRedirectionsTitle} ${
                        styles.toggleContainer
                      }`}
                    >
                      <span>
                        Show redirection page after survey is completed (mobile
                        only)
                      </span>
                      <span
                        role="presentation"
                        className={styles.switchContainer}
                      >
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className={styles.switch} htmlFor="checkbox">
                          <input
                            type="checkbox"
                            checked={survey && survey.showRedirectionPageMobile}
                            readOnly
                          />
                          <span
                            className="slider round survey-property-show-redirection-mobile"
                            role="presentation"
                            onClick={() => {
                              if (survey) {
                                updateSurveySettings(
                                  'showRedirectionPageMobile',
                                  !survey.showRedirectionPageMobile,
                                  false
                                );
                              }
                            }}
                          />
                        </label>
                      </span>
                    </div>
                    {survey && survey.showRedirectionPageMobile ? (
                      <>
                        <div className={styles.row}>
                          <div className={styles.rowText}>Title</div>
                          <CustomCopyField
                            propertyName="surveyRedirectionPageTitle"
                            field={{
                              name:
                                customCopyTranslationKeys.SURVEY_REDIRECTION_PAGE_TITLE,
                              value:
                                customCopyFields[
                                  customCopyTranslationKeys
                                    .SURVEY_REDIRECTION_PAGE_TITLE
                                ]
                            }}
                            updateCustomCopies={updateCustomCopies}
                            customCopyFields={customCopyFields}
                            setCustomCopyFields={setCustomCopyFields}
                            language={surveyLanguage}
                            resize={false}
                          />
                        </div>
                        <div className={styles.row}>
                          <div className={styles.rowText}>Description</div>
                          <CustomCopyField
                            propertyName="surveyRedirectionPageDescription"
                            field={{
                              name:
                                customCopyTranslationKeys.SURVEY_REDIRECTION_PAGE_DESCRIPTION,
                              value:
                                customCopyFields[
                                  customCopyTranslationKeys
                                    .SURVEY_REDIRECTION_PAGE_DESCRIPTION
                                ]
                            }}
                            updateCustomCopies={updateCustomCopies}
                            customCopyFields={customCopyFields}
                            setCustomCopyFields={setCustomCopyFields}
                            language={surveyLanguage}
                            resize={false}
                          />
                        </div>
                        <div className={styles.row}>
                          <div className={styles.rowText}>Button</div>
                          <CustomCopyField
                            propertyName="surveyRedirectionPageButton"
                            field={{
                              name:
                                customCopyTranslationKeys.SURVEY_REDIRECTION_PAGE_BUTTON,
                              value:
                                customCopyFields[
                                  customCopyTranslationKeys
                                    .SURVEY_REDIRECTION_PAGE_BUTTON
                                ]
                            }}
                            updateCustomCopies={updateCustomCopies}
                            customCopyFields={customCopyFields}
                            setCustomCopyFields={setCustomCopyFields}
                            language={surveyLanguage}
                            resize={false}
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                </>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default WebSurveyRedirections;
